import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { getJwtExp } from '@/utils/jwt'

type AuthState = {
  accessToken: string | null
  expiresAt: number | null
  setTokens: (args: { accessToken: string }) => void
  clear: () => void
  isExpired: () => boolean
  needsRefresh: () => boolean
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      accessToken: null,
      expiresAt: null,

      setTokens: ({ accessToken }) => {
        const exp = getJwtExp(accessToken)
        const expiresAt = exp ? exp * 1000 : null
        set({ accessToken, expiresAt })
      },

      clear: () => set({ accessToken: null, expiresAt: null }),

      isExpired: () => {
        const { expiresAt } = get()
        if (!expiresAt) return false
        const LEEWAY_MS = 10_000 // 10 seconds margin
        return Date.now() >= expiresAt - LEEWAY_MS
      },

      needsRefresh: () => {
        const { expiresAt, accessToken } = get()
        if (!expiresAt || !accessToken) return false
        const FIVE_MINUTES_MS = 5 * 60 * 1000
        return Date.now() >= expiresAt - FIVE_MINUTES_MS
      },
    }),
    { name: 'auth' }
  )
)
